import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import {
  BridgingDeal,
  ExistingPlanningChangeTypeEnum,
  InterestServicedorRolledEnum,
  LandOrPropertyEnum,
  OwnOrPurchaseEnum,
  ProductTypeEnum,
  PropertyTypeDetailEnum,
  PropertyTypeEnum,
  SaveBridgingSearchRequest,
  SourceOfIncomeEnum,
  UpdateBridgingSearchGetResultRequest,
  UpdateBridgingSearchGetResultResponse,
  YesNoMaybe,
} from "@src/apis/ModularClient";

export class BridgingDealService extends BaseService<BridgingDeal, number> {
  static $inject = ["$http", "$cookies", "$rootScope", "$q", "$timeout", "BroadcastService"];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/bridgingdeal";
    this.$broadcastBusinessNameSingular = "bridgingdeal";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  debugSearch(dealDto: BridgingDeal): ng.IPromise<[]> {
    let defer = this.$q.defer<[]>();
    this.$http
      .get(this.$baseAddress + "/debugSearch")
      .then((response) => {
        defer.resolve(response.data as []);
      })
      .catch((response) => {
        defer.reject(response);
      });
    return defer.promise;
  }

  clearSearchdata(dealDto) {
    let tempDealDto = dealDto;
    dealDto = {} as BridgingDeal;
    dealDto.MaxLoanRequired = true;
    dealDto.OwnOrPurchase = tempDealDto.OwnOrPurchase;
    dealDto.Locations = tempDealDto.Locations;
    dealDto.HasIsFamilyInResidence = tempDealDto.HasIsFamilyInResidence;
    dealDto.IsFamilyInResidence = tempDealDto.IsFamilyInResidence;
    dealDto.ProductType = tempDealDto.ProductType;
    dealDto.LoanCompletionType = tempDealDto.LoanCompletionType;
    dealDto.PropertyAddress = tempDealDto.PropertyAddress;

    if (!dealDto.HasIsFamilyInResidence) {
      dealDto.HasIsFamilyInResidence = tempDealDto.HasIsFamilyInResidence;
      dealDto.HasOwnOrPurchase = false;
      dealDto.OwnOrPurchase = OwnOrPurchaseEnum.Purchasing;
      dealDto.LandOrProperty =
        dealDto.ProductType == ProductTypeEnum.BridgingPurchaseOrRefinance
          ? LandOrPropertyEnum.Property
          : LandOrPropertyEnum.Land;
      dealDto.HasLandOrProperty = dealDto.ProductType == ProductTypeEnum.BridgingPurchaseOrRefinance ? true : false;
    }
    return dealDto;
  }

  datasetupOnOwnOrPurchaseChange(dealDto) {
    if (dealDto.OwnOrPurchase != null && dealDto.OwnOrPurchase == OwnOrPurchaseEnum.Purchasing) {
      dealDto.OriginalPurchaseDate = null;
      dealDto.Currentvalue = null;
    }
    return dealDto;
  }

  datasetupOnLandorPropertyChange(dealDto) {
    if (dealDto.ProductType == ProductTypeEnum.BridgingPreconstruction) {
      if (dealDto.LandOrProperty == LandOrPropertyEnum.Property) {
        dealDto.EndPropertyType = PropertyTypeEnum.None;
        dealDto.IsTenantedBuilding = null;
        dealDto.BuildingCondition = null;
        dealDto.LandTotalOtherCosts = 0;
        dealDto.IsMortgaged = false;
        dealDto.MortgageCurrentLender = "";
        dealDto.MortgageCurrentBalance = 0;
      } else if (dealDto.LandOrProperty == LandOrPropertyEnum.Land) {
        dealDto.PurchaseCosts = 0;
      }
    } else if (dealDto.ProductType == ProductTypeEnum.BridgingPurchaseOrRefinance) {
      if (dealDto.LandOrProperty == LandOrPropertyEnum.Property) {
        dealDto.EndPropertyType = PropertyTypeEnum.Residential;
      } else if (dealDto.LandOrProperty == LandOrPropertyEnum.Land) {
        dealDto.EndPropertyType = PropertyTypeEnum.None;
        dealDto.PropertyTypeDetail = PropertyTypeDetailEnum.None;
        dealDto.PropertyTenure = null;
        dealDto.IsTenantedBuilding = false;
        dealDto.BuildingCostTodate = 0;
        dealDto.IsPropertyImprovementDuringLoanTerm = false;
        dealDto.IsExistingPlanChange = false;
        dealDto.ExistingPlanningChangeType = ExistingPlanningChangeTypeEnum.None;
        dealDto.PurchasePrice = 0;
        dealDto.PurchaseCosts = 0;
        dealDto.HasCompletionDate = YesNoMaybe.No;
        dealDto.CompletionDate = null;
        dealDto.NumberOfTenancies = null;
        dealDto.GrossAnnualRentalReceipts = null;
        dealDto.BuildingCondition = null;
        dealDto.Currentvalue = 0;
      }
    }

    return dealDto;
  }

  datasetupOnInterestServiceChange(dealDto) {
    if (dealDto.interestService == InterestServicedorRolledEnum.Rolled) {
      dealDto.sourceOfIncome = null;
    } else {
      dealDto.sourceOfIncome = SourceOfIncomeEnum.None;
    }
    return dealDto;
  }

  datasetupOnIsTenantedBuildingChange(dealDto: BridgingDeal) {
    if (!dealDto.isTenantedBuilding) {
      dealDto.numberOfTenancies = null;
      dealDto.grossAnnualRentalReceipts = null;
      if (dealDto.productType == ProductTypeEnum.BridgingPurchaseOrRefinance) {
        dealDto.buildingCondition = null;
      }
    }
    return dealDto;
  }

  datasetupOnEndPropertyTypeChange(dealDto) {
    if (
      dealDto.EndPropertyType != PropertyTypeEnum.MixedUse &&
      dealDto.EndPropertyType != PropertyTypeEnum.Residential
    ) {
      dealDto.PropertyTypeDetail = null;
      dealDto.HowManyFlats = null;
      dealDto.HowManyHouses = null;
    }
    return dealDto;
  }

  datasetupOnHasCompletionDateChange(dealDto) {
    if (dealDto.HasCompletionDate != 1) {
      dealDto.CompletionDate = null;
    }
    return dealDto;
  }
}
